import { Component } from "react";

// Si una pantalla falla al dibujarse, muestra un mensaje con "Reintentar" en lugar de
// dejar toda la app en blanco. El resto de la app (menú, otras secciones) sigue funcionando.
class LimiteDeError extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Error en la pantalla:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="panel m-6 border-rose-500/30 p-6">
        <h3 className="text-xl font-black uppercase tracking-tight text-white">Esta pantalla tuvo un problema</h3>
        <p className="text-gray-400 text-sm mt-2">
          Puedes intentarlo de nuevo o ir a otra sección del menú. Si se repite, avisa a quien administra el sistema.
        </p>
        <button
          onClick={() => this.setState({ error: null })}
          className="mt-4 btn-primario"
        >
          Reintentar
        </button>
      </div>
    );
  }
}

export default LimiteDeError;
